'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentTabbyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "url(#paint0_linear_647_1982)",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M76.157 21.7932L71.2309 40.9566L71.2196 41H75.056L80 21.7932H76.157Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.1991 32.6996C14.6237 32.9883 13.9906 33.1373 13.3493 33.1348C11.9676 33.1348 11.1836 32.91 11.0984 31.7722V31.6955C11.0984 31.6503 11.0933 31.6103 11.0933 31.5575V28.2437L11.0984 27.8537V25.5175H11.0933V24.5236L11.0984 24.1302V21.8749L7.67136 22.3357C9.98915 21.8783 11.319 20.0098 11.319 18.1472V17H7.46825V22.3655L7.25093 22.4277V32.3641C7.37798 35.1558 9.18341 36.8149 12.1457 36.8149C13.193 36.8149 14.3456 36.5722 15.2283 36.1642L15.2484 36.1557V32.6698L15.1991 32.6996Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.8067 21.0709L5 22.7683V25.56L15.8067 23.8627V21.0709Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.8067 25.1556L5 26.8529V29.5204L15.8067 27.8222V25.1556Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.9349 26.4399C27.782 23.3382 25.8795 21.5003 22.7802 21.5003C20.9982 21.5003 19.5296 22.2012 18.5324 23.5289C17.5353 24.8567 17.0137 26.7977 17.0137 29.1568C17.0137 31.5159 17.5386 33.4628 18.5324 34.7854C19.5262 36.1081 20.9982 36.8141 22.7802 36.8141C25.8795 36.8141 27.782 34.9668 27.9349 31.8489V36.522H31.7798V21.8273L27.9349 22.432V26.4399ZM28.1355 29.1602C28.1355 31.9076 26.7196 33.6826 24.5288 33.6826C22.272 33.6826 20.9221 31.992 20.9221 29.1602C20.9196 26.3122 22.2678 24.6088 24.5263 24.6088C25.6246 24.6088 26.5424 25.0449 27.1801 25.8693C27.8029 26.675 28.133 27.812 28.133 29.1576L28.1355 29.1602Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M43.0145 21.5011C39.9135 21.5011 38.0102 23.3398 37.8598 26.445V17.5485L34.009 18.154V36.5228H37.8598V31.848C38.0102 34.9702 39.9135 36.8192 43.0145 36.8192C46.6429 36.8192 48.8094 33.9567 48.8094 29.1618C48.8094 24.3669 46.6429 21.5011 43.0145 21.5011ZM41.2659 33.6799C39.0743 33.6799 37.6592 31.905 37.6592 29.1576C37.6592 27.8119 37.9885 26.6749 38.612 25.8676C39.2498 25.0432 40.1675 24.6071 41.2659 24.6071C43.5227 24.6071 44.8726 26.3104 44.8726 29.1576C44.8726 31.9894 43.5243 33.6799 41.2659 33.6799Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M59.2952 21.5011C56.1941 21.5011 54.2918 23.3398 54.1405 26.445V17.5485L50.2897 18.154V36.5228H54.1405V31.848C54.2918 34.9702 56.1941 36.8192 59.2952 36.8192C62.9235 36.8192 65.0903 33.9567 65.0903 29.1618C65.0903 24.3669 62.9235 21.5011 59.2952 21.5011ZM57.5466 33.6799C55.3558 33.6799 53.9399 31.905 53.9399 29.1576C53.9399 27.8119 54.2692 26.6749 54.8927 25.8676C55.5305 25.0432 56.4483 24.6071 57.5466 24.6071C59.8033 24.6071 61.1533 26.3104 61.1533 29.1576C61.1533 31.9894 59.805 33.6799 57.5466 33.6799Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M65.0992 21.7932H69.2107L72.5511 36.4955H68.8649L65.0992 21.7932Z",
          fill: "#292929"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_647_1982",
          x1: 84,
          y1: 29,
          x2: -2.27066e-8,
          y2: 29,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#7FF9C8" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#7EF9AB" })
          ]
        }
      ) })
    ]
  }
);
const VpPaymentTabbyAsset = forwardRef(PaymentTabbyAsset);

export { VpPaymentTabbyAsset as default };
